import showdown from "showdown";

/**
 * Converts a string with newline-separated text into an HTML string
 * where each line is wrapped in a paragraph tag with specific styling.
 *
 * @param {string} inputString - The input string containing text separated by newline characters.
 * @return {string} The resulting HTML string with each line wrapped in a styled paragraph tag.
 */
export function convertToHtmlWithParagraphs(inputString: string) {
  return inputString
    .split("\n")
    .map((line) => `<p style="margin: 0;">${line}</p>`)
    .join("");
}
/**
 * Converts markdown to HTML and replaces newlines with HTML paragraphs.
 * @param body The email body to process.
 */
export function processEmailBody(body: string) {
  const converter = new showdown.Converter();
  const htmlContent = converter.makeHtml(body);
  return convertToHtmlWithParagraphs(htmlContent);
}
